// extracted by mini-css-extract-plugin
export default {"Toggle":"_Toggle--j5MrF"};